<template>
  <PageSection class="similar_vacancies">
    <SectionBox>
      <BasicSection v-if="vacancies.length" class="similar_vacancy__section">
        <SectionTitle title="Похожие вакансии" divider />
        <BasicSlider
          :slides="vacancies"
          pagination-under
          bounds="with-pagination"
          prev-title="Предыдущая вакансия"
          next-title="Следующая вакансия"
          v-slot="{ slide: vacancy }"
          ref="slider"
        >
            <SimilarVacancy
              :key="`slide-${vacancy.id}`"
              :vacancy="vacancy" />
        </BasicSlider>
      </BasicSection>
    </SectionBox>
  </PageSection>
</template>

<script>
  import BasicSlider from 'src/components/BasicSlider/BasicSlider.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import PageSection from 'src/components/sections/PageSection/PageSection.vue';
  import SectionTitle from 'src/components/sections/SectionTitle/SectionTitle.vue';
  import SimilarVacancy from 'src/components/vacancies/SimilarVacancy/SimilarVacancy.vue';

  export default {
    name: 'SimilarVacanciesSlider',
    
    components: {
      PageSection,
      SectionBox,
      BasicSection,
      SectionTitle,
      BasicSlider,
      SimilarVacancy,
    },
    
    props: {
      vacancies: {
        type: Array,
        default: () => []
      }
    },
  }
</script>